import { useState } from "react";
import { Key, ArrowLeft } from "iconsax-reactjs";
import { useNavigate } from "react-router-dom";

export default function ForgotPasswordScreen() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!email.trim()) return;

    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      // Handle password reset logic here
      console.log("Password reset requested for:", email);
    }, 1500);
  };

  const handleBackToLogin = () => {
    // Navigate back to login - replace with your routing logic
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-[#0C0E12] flex flex-col items-center justify-between p-4 relative">
      {/* Main Content Container */}
      <div className="w-full max-w-md mt-auto">
        {/* Icon */}
        <div className="flex justify-center mb-8">
          <div className="w-16 h-16 bg-[#0C0E12] rounded-lg flex items-center justify-center border border-gray-700">
            <Key className="w-8 h-8 text-gray-400" />
          </div>
        </div>

        {/* Main Content */}
        <div className="text-center mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-white mb-4">
            Forgot password?
          </h1>
          <p className="text-gray-400 text-sm sm:text-base px-2">
            No worries, we will send you reset instructions.
          </p>
        </div>

        {/* Form */}
        <div className="space-y-6">
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-white mb-2"
            >
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="w-full px-4 py-3 bg-[#0C0E12] border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200"
            />
          </div>

          <button
            onClick={handleSubmit}
            disabled={isLoading}
            className="w-full py-2.5 sm:py-3 text-white rounded-lg font-medium transition-all duration-300 mt-4 sm:mt-6 relative 
             hover:scale-[1.02] hover:shadow-xl text-sm sm:text-base"
            style={{
              background:
                "radial-gradient(50% 50% at 50% 50%, #744EC5 0%, #5A3D9A 100%)",
              border: "1px solid",
              borderImageSource:
                "radial-gradient(50% 50% at 50% 50%, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)",
              boxShadow: `
      0px 36px 32px -16px #7F56D936,
      0px 8px 16px 0px #7F56D91F,
      0px 2px 4px -8px #7F56D914,
      0px 8px 24px -16px #FFFFFF3D inset,
      0px -24px 32px 0px #FFFFFF38 inset,
      0px 0px 12px 0px #FFFFFF inset
    `,
              borderImageSlice: "1",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background =
                "radial-gradient(50% 50% at 50% 50%, #8462D3 0%, #6647AB 100%)";
              e.currentTarget.style.boxShadow = `
      0px 42px 36px -12px #8D5EE680,
      0px 12px 20px 0px #7F56D93D,
      0px 4px 8px -4px #7F56D928,
      0px 12px 28px -12px #7F56D9 inset,
      0px -28px 36px 0px #FFFFFF4D inset,
      0px 0px 16px 0px #FFFFFF inset
    `;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background =
                "radial-gradient(50% 50% at 50% 50%, #744EC5 0%, #5A3D9A 100%)";
              e.currentTarget.style.boxShadow = `
      0px 36px 32px -16px #7F56D936,
      0px 8px 16px 0px #7F56D91F,
      0px 2px 4px -8px #7F56D914,
      0px 8px 24px -16px #FFFFFF3D inset,
      0px -24px 32px 0px #FFFFFF38 inset,
      0px 0px 12px 0px #FFFFFF inset
    `;
            }}
          >
            {isLoading ? (
              <div className="flex items-center justify-center">
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                Sending...
              </div>
            ) : (
              "Reset password"
            )}
          </button>
        </div>

        {/* Back to Login */}
        <button
          onClick={handleBackToLogin}
          className="w-full mt-6 py-3 px-4 text-gray-400 hover:text-white font-medium transition-colors duration-200 flex items-center justify-center group"
        >
          <ArrowLeft className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform duration-200" />
          Back to login
        </button>
      </div>

      {/* Footer - positioned at bottom left */}
      <div className="w-full text-left p-4 mt-auto">
        <p className="text-gray-500 text-xs sm:text-sm">© Gradeateam 2025</p>
      </div>
    </div>
  );
}
